import { ReactNode } from 'react';
import { CircularProgress } from '@mui/material';
import { Navigate } from 'react-router-dom';

import { LoaderContainer } from '../styled/App.styled';

import { useUserMeta } from '../hooks/useUserData';

interface ProtectedRouteProps {
  children: ReactNode;
  requireAdmin?: boolean;
}

const RedirectAdmin = ({ children, requireAdmin }: ProtectedRouteProps) => {
  const { userMeta, loading } = useUserMeta();

  if (loading) {
    return (
      <LoaderContainer>
        <CircularProgress />
      </LoaderContainer>
    );
  }

  if (
    !requireAdmin &&
    userMeta &&
    (userMeta.role === 'admin' || userMeta.role === 'auditor')
  ) {
    return <Navigate to="/dashboard" replace />;
  }

  if (requireAdmin && userMeta?.role !== 'admin') {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default RedirectAdmin;
